export default "__VITE_ASSET__BhLDrTJx__"